import {
  Control,
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';

import { useState } from 'react';
import SharedTransferList from '../../../../shared/shared-transfer-list';
import { GmailDeletionFormValues } from '../gmail-deletion-form-page';

import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';

interface StepSourcesProps {
  control: Control<GmailDeletionFormValues>;
  setValue: UseFormSetValue<GmailDeletionFormValues>;
  watch: UseFormWatch<GmailDeletionFormValues>;
  errors: FieldErrors<GmailDeletionFormValues>;
  domains: string[];
  trigger: UseFormTrigger<GmailDeletionFormValues>;
  clearErrors: UseFormClearErrors<GmailDeletionFormValues>;
}

export default function StepSources({
  control,
  setValue,
  watch,
  errors,
  domains,
  trigger,
  clearErrors,
}: StepSourcesProps) {
  const targets = watch('sources')!;
  const [isAlreadySelected, setIsAlreadySelected] = useState(false);
  const sourceType = watch('sourceType');

  // function addSelection(email: string) {
  //   if (targets.includes(email)) {
  //     setIsAlreadySelected(true);
  //   } else {
  //     setIsAlreadySelected(false);
  //     setValue('sources', [...targets, email]);
  //     setNewUserKey(new Date().getTime().toString());
  //     setNewGroupKey('Group - ' + new Date().getTime().toString());
  //     setNewDomainKey('Domain - ' + new Date().getTime().toString());
  //     setNewOrgKey('Org - ' + new Date().getTime().toString());
  //     setAutoCompleteResponse('');
  //   }
  // }

  function addSelection(emails: string[]) {
    const uniqueEmails = Array.from(new Set([...targets!, ...emails]));
    setValue('sources', uniqueEmails, {
      shouldDirty: true,
    });
    clearErrors();
    if (uniqueEmails.length === 0) {
      trigger('sources');
    }
  }

  function removeSelection(emails: string[]) {
    const newList = targets!.filter((userEmail) => !emails.includes(userEmail));
    setValue('sources', newList, {
      shouldDirty: true,
    });
  }

  return (
    <Box
      sx={{
        viewTransitionName: 'steps',
        height: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack gap={1} alignItems="center" sx={{ height: '100%' }}>
        <Stack
          flexDirection={'row'}
          gap={4}
          alignItems={'center'}
          justifyContent="center"
          sx={{ flexShrink: 0 }}
        >
          <Controller
            name={`sourceType`}
            control={control}
            render={({ field: props }) => {
              return (
                <FormControl>
                  <FormLabel>
                    {targets.length > 0
                      ? 'Source Type (Only one source type is allowed)'
                      : 'Source Type'}
                  </FormLabel>
                  <RadioGroup
                    aria-labelledby="radio-buttons-group-label"
                    defaultValue="User"
                    name="radio-buttons-group"
                    value={props.value}
                    onChange={(e) => {
                      if (isAlreadySelected) {
                        setIsAlreadySelected(false);
                      }
                      props.onChange(e.target.value);
                    }}
                    row
                  >
                    <FormControlLabel
                      value="User"
                      control={<Radio />}
                      label="User"
                      disabled={targets.length > 0}
                    />
                    <FormControlLabel
                      value="Group"
                      control={<Radio />}
                      label="Group"
                      disabled={targets.length > 0}
                    />
                    <FormControlLabel
                      value="OrgUnit"
                      control={<Radio />}
                      label="Org Unit"
                      disabled={targets.length > 0}
                    />
                    <FormControlLabel
                      value="Domain"
                      control={<Radio />}
                      label="Domain"
                      disabled={targets.length > 0}
                    />
                  </RadioGroup>
                </FormControl>
              );
            }}
          />
        </Stack>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            width: '100%',
          }}
        >
          <Controller
            rules={{
              required: 'Source is required.',
            }}
            name={'sources'}
            control={control}
            render={() => (
              <SharedTransferList
                sources={targets}
                addSelection={addSelection}
                removeSelection={removeSelection}
                errors={!!errors.sources}
                helperText={errors?.sources?.message || ' '}
                domains={domains || []}
                sourceType={sourceType}
                hasSelectAllOption={false}
              />
            )}
          />
        </Box>
      </Stack>
    </Box>
  );
}
